import React from "react";
import { Button, Spinner, Image } from "react-bootstrap";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { AppState, LogoutOptions, RedirectLoginOptions, User } from "@auth0/auth0-react";

const AuthContainer = styled.div`
  margin-right: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  button {
    margin-left: 0.25rem;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    height: 100%;
  }
  span {
    margin-right: 0.25rem;
  }
`;

const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  gap: 0.25rem;
  img {
    width: 30px;
    height: 30px;
  }
`;

const AuthComponent = ({
  loginWithRedirect,
  isAuthenticated,
  user,
  logout,
  isLoading,
}: {
  loginWithRedirect: (options?: RedirectLoginOptions<AppState> | undefined) => Promise<void>;
  isAuthenticated: boolean;
  user: User;
  logout: (options?: LogoutOptions | undefined) => void;
  isLoading: boolean;
}): JSX.Element => {
  const { t } = useTranslation();

  const [imageLoaded, setImageLoaded] = React.useState<boolean>(false);
  // console.log({ imageLoaded });

  const handleLogin = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: "/",
      },
    });
  };

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <React.Fragment>
      <AuthContainer>
        {isLoading ? <Spinner animation="border" variant="primary" /> : null}
        {isAuthenticated ? (
          <UserContainer>
            <Spinner
              animation="grow"
              variant="primary"
              style={{
                display: !imageLoaded ? "block" : "none",
              }}
            />
            <Image
              src={user.picture}
              roundedCircle
              alt="User Gravatar"
              onLoad={() => setImageLoaded(true)}
              style={{
                display: imageLoaded ? "block" : "none",
              }}
            />
            <span className="span_bold span_italic">{user?.email}</span>
          </UserContainer>
        ) : null}
        {!isAuthenticated ? (
          <Button onClick={handleLogin} variant={"primary"} size="sm">
            {t("Login")}
          </Button>
        ) : null}
        {isAuthenticated ? (
          <Button onClick={handleLogout} variant={"warning"} size="sm">
            {t("Logout")}
          </Button>
        ) : null}
      </AuthContainer>
    </React.Fragment>
  );
};

export default AuthComponent;
